import { StyleSheet } from 'react-native';
import { BaseToast, ErrorToast, type ToastConfig } from 'react-native-toast-message';
import Colors from 'src/core/utils/Colors';
import Dimens from 'src/core/utils/Dimens';

const TOAST_MESSAGE_LINES = 2;

export const toastConfig: ToastConfig = {
	success: (props) => (
		<BaseToast
			{...props}
			contentContainerStyle={styles.contentContainer}
			style={styles.successToast}
			text1Style={styles.successTitle}
			text2NumberOfLines={TOAST_MESSAGE_LINES}
			text2Style={styles.successMessage}
		/>
	),
	error: (props) => <ErrorToast {...props} text1Style={styles.errorTitle} text2Style={styles.errorMessage} />,
};

const styles = StyleSheet.create({
	contentContainer: {
		paddingHorizontal: Dimens.padding15,
	},
	successToast: {
		borderLeftColor: Colors.successToastBorder,
	},
	successTitle: {
		fontSize: Dimens.fontSize15,
		fontWeight: Dimens.fontWeight400,
	},
	successMessage: {
		fontSize: Dimens.fontSize12,
		textAlign: 'center',
		color: Colors.gray700,
	},
	errorTitle: {
		fontSize: Dimens.fontSize17,
	},
	errorMessage: {
		fontSize: Dimens.fontSize15,
	},
});
